import { render, staticRenderFns } from "./OdontogramTreatment.vue?vue&type=template&id=13829eeb"
import script from "./OdontogramTreatment.vue?vue&type=script&lang=js"
export * from "./OdontogramTreatment.vue?vue&type=script&lang=js"
import style0 from "./OdontogramTreatment.vue?vue&type=style&index=0&id=13829eeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports